import React from "react";
import AdminNavbar from "./AdminNavbar";
import Sidebar from "./Sidebar";
import AdminDashboard from "./AdminDashboard";

import "../assets/css/admin/adminLayout.css";
import Footer from "../components/common/Footer";

function AdminLayout() {

    return (

        <div className="admin-layout">

    <AdminNavbar />

    <div className="admin-main">

        <Sidebar />

        <div className="admin-content">

            <AdminDashboard />

        </div>

    </div>
 <Footer/>
</div>
 
    );

}

export default AdminLayout;